import { Toaster } from '@/libs/components/src/lib/ui/sonner';
import { use } from 'react';
import { ThemeContext } from '../../../contexts/theme.context';

const Toasts: React.FC = () => {
  const { theme } = use(ThemeContext);

  return (
    <Toaster
      theme={theme}
      position="bottom-left"
      richColors
      closeButton
      visibleToasts={9}
      className="print:hidden"
      // Radix modals (common/Modal) set pointer-events:none on <body> while
      // open; the toaster inherits it, leaving the toast (and its close X)
      // unclickable whenever a modal is up. Force it back on.
      toastOptions={{ style: { pointerEvents: 'auto' } }}
    />
  );
};

export default Toasts;
